import { useState } from "react";
import { newsFeed } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

const tabs = ["实时短讯", "高热度", "求证中"];

export default function NewsFeed() {
  const [tab, setTab] = useState("实时短讯");
  const list = tab === "高热度" ? [...newsFeed].sort((a, b) => b.hot - a.hot) : newsFeed;

  return (
    <section id="feed" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <SectionHead
          kicker="flashlight-line"
          title="短讯速览 · 高频刷新"
          sub="最新的曝光与跟进以短讯形式即时滚动，信息量大、更新密集。"
        />
        <div className="mb-6 flex w-fit flex-row items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1 md:mb-8">
          {tabs.map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={
                tab === t
                  ? "whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-sm text-background-50"
                  : "whitespace-nowrap rounded-full px-4 py-1.5 text-sm text-foreground-600 hover:text-foreground-950"
              }
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-x-8 lg:grid-cols-2">
        {list.map((it, i) => (
          <a
            key={`${it.title}-${i}`}
            href="#feed"
            className="group flex items-start gap-3 border-b border-background-200 py-3 transition-colors"
          >
            <span className="mt-1 inline-flex shrink-0 items-center rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900">
              {it.tag}
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm leading-relaxed text-foreground-800 group-hover:text-foreground-950 md:text-[15px]">
                {it.title}
              </p>
              <div className="mt-1.5 flex flex-wrap items-center gap-2 text-[11px] text-foreground-400">
                <span>{it.time}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {it.reads}
                </span>
                <span className="flex items-center gap-1 text-accent-600">
                  <i className="ri-fire-fill" aria-hidden="true" />
                  {it.hot}
                </span>
              </div>
            </div>
            <i
              className="ri-arrow-right-up-line mt-1 shrink-0 text-foreground-300 transition-colors group-hover:text-primary-500"
              aria-hidden="true"
            />
          </a>
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <button
          onClick={() => setTab(tab)}
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2 text-sm text-foreground-700 hover:border-background-400"
        >
          加载更多短讯
          <i className="ri-arrow-down-line" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}